import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CustomerService } from '../../../../../../../../../../services/customer/customer.service';
import { dateStringFromISO8601 } from '../../../../../../../../../../utils';
import { CustomerMembership, isOutsideCancellationDateRange } from '../../../../../../../../../../models/membership';
import { OrganizationConfigService } from '../../../../../../../../../../services/organization-config/organization-config.service';

@Component({
  selector: 'app-edit-recurring-customer-membership-cancel-future-bill-date',
  templateUrl: './edit-recurring-customer-membership-cancel-future-bill-date.component.html',
  styleUrls: ['./edit-recurring-customer-membership-cancel-future-bill-date.component.css']
})
export class EditRecurringCustomerMembershipCancelFutureBillDateComponent implements OnInit, OnDestroy {

  @Input() membership: CustomerMembership;
  @Input() savedCallback: (successMessage: string) => undefined;
  @Input() saveClickedObservable: Observable<void>;
  @Output() loadingEvent = new EventEmitter<boolean>();
  @Output() serverErrorEvent = new EventEmitter<number>();

  public effectiveDate: string = null;
  public reason: string = null;

  public errorMessage = '';

  public dateStringFromISO8601 = dateStringFromISO8601;
  public isOutsideCancellationDateRange = isOutsideCancellationDateRange;

  private saveClickedSubscription: Subscription;

  constructor(
    public orgConfigService: OrganizationConfigService,
    private activeModal: NgbActiveModal,
    private customerService: CustomerService
  ) {}

  ngOnInit() {
    this.saveClickedSubscription = this.saveClickedObservable.subscribe(() => {
      this.handleSave();
    });

    // Reload the org config, in case the membership cancellation reason policy has changed.
    this.orgConfigService.loadOrganizationConfig();
  }

  ngOnDestroy() {
    this.saveClickedSubscription.unsubscribe();
  }

  private handleSave() {
    const orgConfig = this.orgConfigService.getOrganizationConfig();
    if (this.effectiveDate === null) {
      this.errorMessage = 'Please select a date for the cancellation to take effect.';
      return;
    }
    if (orgConfig.require_membership_cancellation_reason && (this.reason === null)) {
      this.errorMessage = 'Please select a reason for the cancellation.';
      return;
    }

    this.loadingEvent.emit(true);

    this.errorMessage = '';

    this.customerService
      .cancelMembershipFutureBillDate(
        this.membership,
        this.effectiveDate,
        this.reason
      )
      .then(() => {
        this.savedCallback('Membership successfully scheduled for cancellation.');
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to cancel this membership.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverErrorEvent.emit(reason.status);
        }
      })
      .finally(() => { this.loadingEvent.emit(false); });
  }

}
